import { OlMapAdapter } from './OlMapAdapter';

export default OlMapAdapter;
